/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { VesselInfoProps } from '../redux/types';
import { RootState } from '../../../redux/rootState';

function CommonTableWithTwoColumn({ data }:VesselInfoProps) {
  const { themePdfColor, reportPdfResponse3 } = useSelector((state:RootState) => state.reportPdfSliceReducer);
  const { BorderColor, MainColor } = themePdfColor;

  const offset = useMemo(() => {
    if (reportPdfResponse3?.Tube_Bundle_Layout) {
      const vessel = reportPdfResponse3?.Tube_Bundle_Layout?.flat()?.find(((v) => (v?.JobOrder === data?.JobOrder && v?.VesselId === String(data?.VesselId || ''))));
      if (vessel) {
        return vessel.Offset;
      }
      return '';
    }
    return '';
  }, [reportPdfResponse3]);

  const [isSec1Available, isSec2Available, isSec3Available] = useMemo(() => {
    const one = data?.VesselName1 && data?.VesselName1?.length > 0;
    const two = data?.VesselName2 && data?.VesselName2?.length > 0;
    const three = data?.VesselName3 && data?.VesselName3?.length > 0;
    return [one, two, three];
  }, [data]);

  if (data?.IsMultiOffset === true) {
    return (
      <table className="bordered-table w100 mxWidth800 pb30 mb30 noTableBreak">
        <div
          className="tableAfterThickBorderStyle"
          style={{
            backgroundColor: BorderColor,
          }}
        />
        <div
          className="tableBeforeThickBorderStyle"
          style={{
            backgroundColor: BorderColor,
          }}
        />
        <tr>
          <td className="tableGreenHeading textRight boldText" style={{ backgroundColor: MainColor }}>
            {data.VesselName}
          </td>
          {isSec1Available && (
          <td className="tableGreenHeading textCenter boldText" style={{ backgroundColor: MainColor }}>
            {data.VesselName1}
          </td>
          )}
          {isSec2Available && (
          <td className="tableGreenHeading textCenter boldText" style={{ backgroundColor: MainColor }}>
            {data.VesselName2}
          </td>
          )}
          {isSec3Available && (
          <td className="tableGreenHeading textCenter boldText" style={{ backgroundColor: MainColor }}>
            {data.VesselName3}
          </td>
          )}
        </tr>
        <tr>
          <td className="textRight w30">TestEnd</td>
          {isSec1Available && <td className="textCenter">{data.TestEnd}</td>}
          {isSec2Available && <td className="textCenter">{data.TestEnd}</td>}
          {isSec3Available && <td className="textCenter">{data.TestEnd}</td>}
        </tr>
        <tr>
          <td className="textRight w30">Tube Count</td>
          {isSec1Available && <td className="textCenter">{String(data.Section1Count)}</td>}
          {isSec2Available && <td className="textCenter">{String(data.Section2Count)}</td>}
          {isSec3Available && <td className="textCenter">{String(data.Section3Count)}</td>}
        </tr>
        <tr>
          <td className="textRight w30">Tube Type</td>
          {isSec1Available && <td className="textCenter">{data.TubeType}</td>}
          {isSec2Available && <td className="textCenter">{data.TubeType}</td>}
          {isSec3Available && <td className="textCenter">{data.TubeType}</td>}
        </tr>
        <tr>
          <td className="textRight w30">Tube Material</td>
          {isSec1Available && <td className="textCenter">{data.Material}</td>}
          {isSec2Available && <td className="textCenter">{data.Material}</td>}
          {isSec3Available && <td className="textCenter">{data.Material}</td>}
        </tr>
        <tr>
          <td className="textRight w30">OD</td>
          {isSec1Available && (
          <td className="textCenter">
            {data?.OD1 !== undefined && data?.OD1 !== null
              ? (Number.isInteger(data.OD1) ? Number(data.OD1).toFixed(2) : data.OD1)
              : '-'}
          </td>
          )}
          {isSec2Available && (
          <td className="textCenter">
            {data?.OD !== undefined && data?.OD !== null
              ? (Number.isInteger(data.OD) ? Number(data.OD).toFixed(2) : data.OD)
              : '-'}
          </td>
          )}
          {isSec3Available && (
          <td className="textCenter">
            {data?.OD3 !== undefined && data?.OD3 !== null
              ? (Number.isInteger(data.OD3) ? Number(data.OD3).toFixed(2) : data.OD3)
              : '-'}
          </td>
          )}
        </tr>
        {data?.IsNwtOnly ? (
          <tr>
            <td className="textRight w30">*NWT</td>
            {isSec1Available && <td className="textCenter">{data.Nwt1}</td>}
            {isSec2Available && <td className="textCenter">{data.Nwt}</td>}
            {isSec3Available && <td className="textCenter">{data.Nwt3}</td>}
          </tr>
        ) : (
          <>
            <tr>
              <td className="textRight w30">*NWT/Under Fins</td>
              {isSec1Available && <td className="textCenter">{data.NwtUnderFins1}</td>}
              {isSec2Available && <td className="textCenter">{data.NwtUnderFins}</td>}
              {isSec3Available && <td className="textCenter">{data.NwtUnderFins3}</td>}
            </tr>
            <tr>
              <td className="textRight w30">*NWT/Bell/Land</td>
              {isSec1Available && <td className="textCenter">{data.NwtBell1}</td>}
              {isSec2Available && <td className="textCenter">{data.NWTBell}</td>}
              {isSec3Available && <td className="textCenter">{data.NwtBell3}</td>}
            </tr>
          </>
        )}
        <tr>
          <td className="textRight w30">#/Type Support</td>
          {isSec1Available && <td className="textCenter">{data.TypeSupport}</td>}
          {isSec2Available && <td className="textCenter">{data.TypeSupport}</td>}
          {isSec3Available && <td className="textCenter">{data.TypeSupport}</td>}
        </tr>
        <tr>
          <td className="textRight w30">Tube Numbering</td>
          {isSec1Available && <td className="textCenter">{offset?.length > 0 ? (offset === '1' ? 'Top to Bottom' : 'Left to Right') : data.TubeNumbering}</td>}
          {isSec2Available && <td className="textCenter">{offset?.length > 0 ? (offset === '1' ? 'Top to Bottom' : 'Left to Right') : data.TubeNumbering}</td>}
          {isSec3Available && <td className="textCenter">{offset?.length > 0 ? (offset === '1' ? 'Top to Bottom' : 'Left to Right') : data.TubeNumbering}</td>}
        </tr>
        <tr>
          <td className="textRight w30">Row Numbering</td>
          {isSec1Available && <td className="textCenter">{offset?.length > 0 ? (offset === '1' ? 'Left to Right' : 'Top to Bottom') : data.RowNumbering}</td>}
          {isSec2Available && <td className="textCenter">{offset?.length > 0 ? (offset === '1' ? 'Left to Right' : 'Top to Bottom') : data.RowNumbering}</td>}
          {isSec3Available && <td className="textCenter">{offset?.length > 0 ? (offset === '1' ? 'Left to Right' : 'Top to Bottom') : data.RowNumbering}</td>}
        </tr>
        <tr>
          <td className="textRight w30">Tube Length +- 2</td>
          {isSec1Available && <td className="textCenter">{`${data.TubeLength} inches`}</td>}
          {isSec2Available && <td className="textCenter">{`${data.TubeLength} inches`}</td>}
          {isSec3Available && <td className="textCenter">{`${data.TubeLength} inches`}</td>}
        </tr>
      </table>
    );
  }

  return (
    <table className="bordered-table w100 mxWidth400 pb30 mb30 noTableBreak">
      <div
        className="tableAfterThickBorderStyle"
        style={{
          backgroundColor: BorderColor,
        }}
      />
      <div
        className="tableBeforeThickBorderStyle"
        style={{
          backgroundColor: BorderColor,
        }}
      />
      <tr>
        <td colSpan={2} className="tableGreenHeading textCenter boldText" style={{ backgroundColor: MainColor }}>
          {data.VesselName}
        </td>
      </tr>
      <tr>
        <td className="textRight w45">TestEnd</td>
        <td className="textCenter w55">{data.TestEnd}</td>
      </tr>
      <tr>
        <td className="textRight w45">Tube Count</td>
        <td className="textCenter w55">{data.TubeCount}</td>
      </tr>
      <tr>
        <td className="textRight w45">Tube Type</td>
        <td className="textCenter w55">{data.TubeType}</td>
      </tr>
      <tr>
        <td className="textRight w45">Tube Material</td>
        <td className="textCenter w55">{data.Material}</td>
      </tr>
      <tr>
        <td className="textRight w45">OD</td>
        <td className="textCenter w55">
          {data?.OD !== undefined && data?.OD !== null
            ? (Number.isInteger(data.OD) ? Number(data.OD).toFixed(2) : data.OD)
            : '-'}
        </td>
      </tr>
      {data?.IsNwtOnly ? (
        <tr>
          <td className="textRight w45">*NWT</td>
          <td className="textCenter w55">{data.Nwt}</td>
        </tr>
      ) : (
        <>
          <tr>
            <td className="textRight w45">*NWT/Under Fins</td>
            <td className="textCenter w55">{data.NwtUnderFins}</td>
          </tr>
          <tr>
            <td className="textRight w45">*NWT/Bell/Land</td>
            <td className="textCenter w55">{data.NWTBell}</td>
          </tr>
        </>
      )}
      <tr>
        <td className="textRight w45">#/Type Support</td>
        <td className="textCenter w55">{data.TypeSupport}</td>
      </tr>
      <tr>
        <td className="textRight w45">Tube Numbering</td>
        <td className="textCenter w55">{offset?.length > 0 ? (offset === '1' ? 'Top to Bottom' : 'Left to Right') : data.TubeNumbering}</td>
      </tr>
      <tr>
        <td className="textRight w45">Row Numbering</td>
        <td className="textCenter w55">{offset?.length > 0 ? (offset === '1' ? 'Left to Right' : 'Top to Bottom') : data.RowNumbering}</td>
      </tr>
      <tr>
        <td className="textRight w45">Tube Length +- 2</td>
        <td className="textCenter w55">{`${data.TubeLength} inches`}</td>
      </tr>
    </table>
  );
}

export default CommonTableWithTwoColumn;
